export enum AuthenticationStateEnum {
  NOT_AUTHENTICATED = 'not_authenticated',
  LOGGED_IN_TWO_FACTOR_AUTHENTICATION_NOT_ENABLED = 'logged_in_two_factor_authentication_not_enabled',
  LOGGED_IN_NOT_TWO_FACTOR_AUTHENTICATED = 'logged_in_not_two_factor_authenticated',
  AUTHENTICATED = 'authenticated',
}
